import { render, staticRenderFns } from "./RemovePropertyDiscount.vue?vue&type=template&id=63a9e4f2&"
import script from "./RemovePropertyDiscount.vue?vue&type=script&lang=js&"
export * from "./RemovePropertyDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports